<div>
    <button aria-label="Bouton Actions"
            class="btn-dropdown"
            type="button"
            (click)="stopPropagation ? $event.stopPropagation() : null"
            [matMenuTriggerFor]="actionsMenu">
        <i class="far fa-ellipsis-v"></i>
    </button>

    <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before" [overlapTrigger]="false">
        <ng-container *ngTemplateOutlet="projectedContent"></ng-container>
    </mat-menu>

    <ng-template #projectedContent>
        <ng-content></ng-content>
    </ng-template>
</div>
